module.exports = __webpack_public_path__ + "img/christmastree.8eb34ff2.png";